import classNames from 'classnames'
import React from 'react'

interface ObscurePasswordProps {
    errors?: { password?: string }
    obscurePassword: boolean
    setObscurePassword: React.Dispatch<React.SetStateAction<boolean>>
}

const ObscurePassword = ({ errors = {}, obscurePassword, setObscurePassword }: ObscurePasswordProps) => {
    const toggleObscurePassword = () => {
        setObscurePassword((value) => !value)
    }

    return (
        !errors.password && (
            <button
                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                type="button"
                id="password-addon"
                onClick={toggleObscurePassword}
            >
                <i
                    className={classNames('mdi align-middle', {
                        'mdi-eye': obscurePassword,
                        'mdi-eye-off': !obscurePassword,
                    })}
                />
            </button>
        )
    )
}

export default ObscurePassword
